// URL query params
export const QUERY_PARAM = {
  REDIRECT_PATH: 'r',
  AUTH_TOKEN: 'authToken',
  TEAM_ID: 'teamId',
};

export const dataAttributeNames = {
  wordStart: 'data-wordstart',
  bar: 'data-bar',
  addNote: 'data-add-note',
  tagManagementPopover: 'data-tag-management-popover',
};

export const AttributeIds = {
  transcriptUtteranceScrollableContainer: 'transcript-utterance-scrollable-container',
  transcriptUtteranceContainer: 'transcript-utterance-container',
};

export const zIndexes = {
  insightCollectionMiddleHeaderMiddleContainer: 1,
  insightCollectionHeaderCustomizationDrawer: 2,
  transcriptContainer: 2,
  loadingSkeleton: 3,
  noteIconButton: 3,
  playbackTag: 3,
};

export const searchParamNames = {
  collectionCode: 'collectionCode',
} as const;
